import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import DesktopNavLinkGroup from 'components/nav/DesktopHeader/components/DesktopNavLinkGroup';
import DesktopNavCategorySectionContent from '../DesktopNavCategorySectionContent';
const DesktopNavCategorySectionUI = t0 => {
  const $ = _c(42);
  const {
    items: t1,
    secondaryItems: t2,
    ctaLabel,
    ctaUrl,
    customContent: categoryCustomContent,
    id,
    image: categoryImage,
    imageLabel: categoryImageLabel,
    isOpen: t3,
    selectedSubcategory: selectedSubcategoryId,
    setIsTitleHovered,
    setIsSectionHovered
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const items = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const secondaryItems = t5;
  const isOpen = t3 === undefined ? false : t3;
  let t6;
  if ($[4] !== items || $[5] !== secondaryItems || $[6] !== selectedSubcategoryId) {
    t6 = selectedSubcategoryId ? items.find(item_0 => item_0.id === selectedSubcategoryId) || secondaryItems.find(item => item.id === selectedSubcategoryId) || null : null;
    $[4] = items;
    $[5] = secondaryItems;
    $[6] = selectedSubcategoryId;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const selectedSubcategory = t6;
  const selectedSubcategoryItems = selectedSubcategory?.items;
  const customContent = selectedSubcategory ? selectedSubcategory.customContent : categoryCustomContent;
  const contentId = `${id}-${selectedSubcategoryId || ""}`;
  const t7 = !isOpen;
  let t8;
  if ($[8] !== isOpen || $[9] !== t7) {
    t8 = classNames("bg-white left-0 pointer-events-none absolute right-0 top-0", {
      "opacity-0": t7,
      "pointer-events-auto": isOpen
    });
    $[8] = isOpen;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = !isOpen;
  let t10;
  if ($[11] !== ctaLabel || $[12] !== ctaUrl || $[13] !== id || $[14] !== items || $[15] !== secondaryItems || $[16] !== selectedSubcategoryId || $[17] !== setIsSectionHovered || $[18] !== setIsTitleHovered) {
    t10 = <div className="flex-1"><div className="flex [&_>_*]:flex"><div><DesktopNavLinkGroup categoryId={id} ctaLabel={ctaLabel} ctaUrl={ctaUrl} items={items} secondaryItems={secondaryItems} selectedItem={selectedSubcategoryId} setIsSectionHovered={setIsSectionHovered} setIsTitleHovered={setIsTitleHovered} /></div></div></div>;
    $[11] = ctaLabel;
    $[12] = ctaUrl;
    $[13] = id;
    $[14] = items;
    $[15] = secondaryItems;
    $[16] = selectedSubcategoryId;
    $[17] = setIsSectionHovered;
    $[18] = setIsTitleHovered;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  let t12;
  if ($[20] !== setIsSectionHovered) {
    t11 = () => {
      setIsSectionHovered(true);
    };
    t12 = () => {
      setIsSectionHovered(false);
    };
    $[20] = setIsSectionHovered;
    $[21] = t11;
    $[22] = t12;
  } else {
    t11 = $[21];
    t12 = $[22];
  }
  let t13;
  if ($[23] !== categoryImage || $[24] !== categoryImageLabel || $[25] !== contentId || $[26] !== ctaUrl || $[27] !== customContent || $[28] !== selectedSubcategory || $[29] !== selectedSubcategoryId || $[30] !== selectedSubcategoryItems || $[31] !== t11 || $[32] !== t12) {
    t13 = <DesktopNavCategorySectionContent categoryImage={categoryImage} categoryImageLabel={categoryImageLabel} categoryUrl={ctaUrl} contentId={contentId} customContent={customContent} selectedSubcategory={selectedSubcategory} selectedSubcategoryItems={selectedSubcategoryItems} selectedSubcategoryId={selectedSubcategoryId} onMouseEnter={t11} onMouseLeave={t12} />;
    $[23] = categoryImage;
    $[24] = categoryImageLabel;
    $[25] = contentId;
    $[26] = ctaUrl;
    $[27] = customContent;
    $[28] = selectedSubcategory;
    $[29] = selectedSubcategoryId;
    $[30] = selectedSubcategoryItems;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== id || $[35] !== t10 || $[36] !== t13) {
    t14 = <FixedWidthContainer className="relative lg:!max-w-[980px]"><div className="bg-white flex justify-between m-0 min-h-[508px] pt-[2.625rem]" data-xc="DesktopNavCategorySection" id={id}>{t10}{t13}</div></FixedWidthContainer>;
    $[34] = id;
    $[35] = t10;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t14 || $[39] !== t8 || $[40] !== t9) {
    t15 = <div className={t8} hidden={t9}>{t14}</div>;
    $[38] = t14;
    $[39] = t8;
    $[40] = t9;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  return t15;
};
DesktopNavCategorySectionUI.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    isNew: PropTypes.bool,
    label: PropTypes.string,
    url: PropTypes.string
  })),
  secondaryItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    isNew: PropTypes.bool,
    label: PropTypes.string,
    url: PropTypes.string
  })),
  ctaLabel: PropTypes.string,
  ctaUrl: PropTypes.string,
  customContent: PropTypes.node,
  id: PropTypes.string,
  image: PropTypes.string,
  imageLabel: PropTypes.string,
  isOpen: PropTypes.bool,
  selectedSubcategory: PropTypes.string,
  setIsTitleHovered: PropTypes.func,
  setIsSectionHovered: PropTypes.func
};
export default DesktopNavCategorySectionUI;